import { Controller } from '@hotwired/stimulus'
import { Dropdown } from 'bootstrap'

export default class ClientPreviewAllyController extends Controller {
  static targets = ['menu', 'toggle']

  connect() {
    this.dropdown = new Dropdown(this.toggleTarget)
    if (this.dropdown._menu === undefined) this.dropdown._menu = this.menuTarget
  }

  toggleDropdown = () => {
    this.dropdown.toggle()
  }
}
